import styled from '../../styles/styled';
import { screenReaderOnly } from '../../styles/a11y_helpers';
const AppText = styled.span(props => {
    return {
        fontSize: props.theme.text.size[props.size],
        color: props.theme.text.color[props.color] || props.theme.colors.grey90,
        fontFamily: props.headingFontFamily
            ? props.theme.text.headingFontFamily
            : props.theme.text.bodyFontFamily,
        fontWeight: getFontWeight(props),
        textTransform: getTextTransform(props),
        marginBlockStart: '0px',
        marginBlockEnd: '0px',
        lineHeight: props.theme.text.lineHeight[props.size],
        overflowWrap: props.overflowWrap,
        ...(props.screenReaderOnly ? screenReaderOnly : {}),
        ...props.style,
    };
});
// TODO: remove this component in favor of better button child alignment solution.
export const ButtonAppText = styled(AppText)(props => {
    return {
        display: 'flex',
        justifyContent: 'space-evenly',
        alignItems: 'center',
        fontcolor: props.color ? props.color : '',
    };
});
ButtonAppText.defaultProps = {
    color: 'dark',
    size: 'medium',
};
function getFontWeight(props) {
    if (props.bold) {
        return 600;
    }
    if (props.semibold || props.headingFontFamily) {
        return 500;
    }
    if (props.light) {
        return 300;
    }
    return 400;
}
function getTextTransform(props) {
    if (props.uppercase) {
        return 'uppercase';
    }
    if (props.capitalize) {
        return 'capitalize';
    }
    return 'none';
}
AppText.defaultProps = {
    color: 'dark',
    size: 'medium',
};
export default AppText;
//# sourceMappingURL=app_text.js.map